module.exports = __webpack_public_path__ + "static/media/shop_img.8317de35.png";